/**
 * Infinite scroll for Dawn collection / search grids (v2).
 * Every "next page" request is built from the current URL, so active filters
 * and sort order are always carried along. Pagination stays as the no-JS fallback.
 * Debug: add ?debug_infinite=1 to the page URL and open the browser console.
 */
(function () {
  var GRID_SEL = '#product-grid';
  var PAG_SEL = '.pagination-wrapper';
  var DEBUG = /[?&]debug_infinite=1/.test(location.search);

  var loading = false;
  var done = false;
  var page = 1;
  var lastKey = null;
  var sentinel = null;
  var io = null;

  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[infinite]'].concat([].slice.call(arguments)));
  }

  // Filter + sort state = URL query without "page"
  function filterKey() {
    var p = new URLSearchParams(location.search);
    p.delete('page');
    return p.toString();
  }

  function currentPage() {
    return parseInt(new URLSearchParams(location.search).get('page') || '1', 10) || 1;
  }

  // Highest page number linked from the pagination block
  function maxLinkedPage(pag) {
    var max = 0;
    if (!pag) return max;
    var links = pag.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      try {
        var n = parseInt(new URL(links[i].getAttribute('href'), location.origin).searchParams.get('page'), 10);
        if (n > max) max = n;
      } catch (e) {}
    }
    return max;
  }

  function hasNext(pag) {
    return maxLinkedPage(pag) > page;
  }

  function reset() {
    page = currentPage();
    lastKey = filterKey();
    done = false;
    log('reset', { page: page, key: lastKey });
  }

  function loadMore() {
    var grid = document.querySelector(GRID_SEL);
    var pag = document.querySelector(PAG_SEL);
    if (!grid || loading || done) return;

    // Filters or sort changed since we last counted: restart from this URL's page
    if (filterKey() !== lastKey) reset();
    if (!hasNext(pag)) {
      log('no next page', { page: page, maxLinked: maxLinkedPage(pag), hasPagination: !!pag });
      return;
    }

    loading = true;
    var keyAtStart = lastKey;
    var params = new URLSearchParams(location.search);
    params.set('page', page + 1);
    var url = location.pathname + '?' + params.toString();
    log('fetching', url);

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        // Filters changed while this request was in flight: drop the result
        if (filterKey() !== keyAtStart) { log('stale result dropped'); return; }

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID_SEL);
        if (!newGrid || !newGrid.children.length) { done = true; log('no grid in response'); return; }

        var added = 0;
        Array.prototype.slice.call(newGrid.children).forEach(function (el) {
          // Dawn's reveal-on-scroll animation would leave appended cards invisible
          el.classList.remove('scroll-trigger', 'animate--slide-in');
          el.removeAttribute('data-cascade');
          el.style.removeProperty('--animation-order');
          grid.appendChild(el);
          added++;
        });
        page += 1;
        log('appended', added, 'now on page', page);

        // Keep pagination state in sync so we know when we've reached the last page
        var newPag = doc.querySelector(PAG_SEL);
        if (pag) pag.innerHTML = newPag ? newPag.innerHTML : '';
        if (!hasNext(pag)) { done = true; log('last page reached'); }
      })
      .catch(function (e) {
        console.error('[infinite] fetch failed', e);
      })
      .then(function () {
        loading = false;
        checkPosition(); // still near the bottom? load the next page too
      });
  }

  // Backup to IntersectionObserver: is the end of the grid within reach?
  function checkPosition() {
    if (!sentinel || !sentinel.isConnected || loading || done) return;
    var top = sentinel.getBoundingClientRect().top;
    if (top < window.innerHeight + 600) loadMore();
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      checkPosition();
    });
  }

  function injectStyle() {
    if (document.getElementById('infinite-scroll-style')) return;
    var s = document.createElement('style');
    s.id = 'infinite-scroll-style';
    s.textContent = 'html.js-infinite .pagination-wrapper{display:none}';
    document.head.appendChild(s);
  }

  function init() {
    var grid = document.querySelector(GRID_SEL);
    if (!grid) return;
    // Already attached to this grid
    if (sentinel && sentinel.isConnected && grid.nextElementSibling === sentinel) return;

    reset();
    injectStyle();
    document.documentElement.classList.add('js-infinite');

    if (io) io.disconnect();
    sentinel = document.createElement('div');
    sentinel.id = 'infinite-sentinel';
    sentinel.style.height = '1px';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadMore();
      }, { rootMargin: '600px' });
      io.observe(sentinel);
    }
    log('attached', { pagination: !!document.querySelector(PAG_SEL), maxLinked: maxLinkedPage(document.querySelector(PAG_SEL)) });
    checkPosition();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn re-renders #ProductGridContainer when a filter or sort is applied: re-attach
  new MutationObserver(function () {
    init();
  }).observe(document.body, { childList: true, subtree: true });
})();
